var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0332 18.5889C20.9033 17.4591 19.5 16.0529 19.5 10.5625C19.5 6.53077 16.5633 3.18556 12.7124 2.5477C12.9001 2.27664 13.0004 1.95469 13 1.625C13 0.727543 12.2725 0 11.375 0C10.4775 0 9.75 0.727543 9.75 1.625C9.75 1.96777 9.85638 2.28556 10.0376 2.5477C6.18673 3.18556 3.24999 6.53077 3.24999 10.5625C3.24999 16.0529 1.84625 17.4591 0.716365 18.5889C-0.814639 20.1199 0.270404 22.75 2.43993 22.75H8.125C8.125 24.5449 9.58008 26 11.375 26C13.1699 26 14.625 24.5449 14.625 22.75H20.3096C22.4748 22.75 23.5673 20.123 22.0332 18.5889ZM11.375 23.9688C11.4827 23.9688 11.5861 24.0116 11.6623 24.0877C11.7384 24.1639 11.7812 24.2673 11.7812 24.375C11.7812 24.4827 11.7384 24.5861 11.6623 24.6623C11.5861 24.7384 11.4827 24.7812 11.375 24.7812C10.255 24.7812 9.34375 23.87 9.34375 22.75H10.1562C10.1562 23.422 10.703 23.9688 11.375 23.9688Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c2f98ec6.svg";
export { ForwardRef as ReactComponent };